import React from 'react';

import StarIcon from '@mui/icons-material/Star';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';

import TooltipTypography from 'UI/components/TooltipTypography/TooltipTypography';
import { useT } from 'UI/lib';

const styles = () => ({
  Tooltip: {
    backgroundColor: '#fff',
    padding: '8px',
    boxShadow: '0 8px 16px -2px #1B212C1F',
    borderRadius: '8px',
    fontSize: 14,
  },
  Popper: {
    opacity: 1,
  },
  icon: {
    color: '#ffa634',
    fontSize: '1rem',
  },
  text: {
    color: '#000',
    fontSize: 14,
  },
  arrow: {
    color: '#fff',
  },
});

const SkillExpertiseLevelTooltipComponent = ({
  classes,
  level,
  supportedLevels,
  tooltipLocizeId,
  children,
  customTooltip,
  disableFocusListener = false,
  additionalText,
  disableTitleText,
  defaultTooltipDisabled,
}) => {
  const t = useT();
  const countStars = supportedLevels.indexOf(level) + 1;
  const text = customTooltip ? customTooltip : t(tooltipLocizeId);
  const disableTooltip = customTooltip ? false : defaultTooltipDisabled;
  return (
    <Tooltip
      disableFocusListener={disableFocusListener || !customTooltip}
      disableHoverListener={disableTooltip}
      arrow
      title={
        !disableTitleText && (
          <>
            <div>
              {Array(countStars)
                .fill(null)
                .map((_, index) => (
                  <StarIcon key={index} className={classes.icon} />
                ))}
            </div>
            <TooltipTypography className={classes.text}>{text}</TooltipTypography>
            <TooltipTypography className={classes.text}>{additionalText}</TooltipTypography>
          </>
        )
      }
      placement="top"
      classes={{ popper: classes.Popper, tooltip: classes.Tooltip, arrow: classes.arrow }}
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export const SkillExpertiseLevelTooltip = withStyles(styles)(SkillExpertiseLevelTooltipComponent);
